<div class="full-page bg-black container-fluid pt-4 pb-3 w-100 p-0">
  <div class="d-flex justify-content-center mb-3">
    <img src="assets/images/club-logo.png" class="logo" />
  </div>
  <div class="user-login-panel text-left">
    <router-outlet></router-outlet>
  </div>
</div>
